var map = {
	"./Pin-Dark-Delegacia.svg": 666,
	"./Pin-Dark-Moto.svg": 667,
	"./Pin-Dark-Ocorrencia.svg": 668,
	"./Pin-Dark-Policial.svg": 669,
	"./Pin-Dark-Viatura.svg": 670,
	"./Pin-Light-Delegacia.svg": 671,
	"./Pin-Light-Moto.svg": 672,
	"./Pin-Light-Ocorrencia.svg": 673,
	"./Pin-Light-Policial.svg": 674,
	"./Pin-Light-Viatura.svg": 675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1255;